import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { Coins, ShoppingCart, Target, ThumbsUp, ThumbsDown, MessageSquare } from "lucide-react";

export const UserStats = ({ stats }) => {
  const { t } = useLanguage();
  if (!stats) return null;
  const spent = Number(stats.total_spent || 0).toFixed(2);
  const items = [
    { key: "balance", icon: Coins, label: t("stats.creditsBalance"), value: stats.credits ?? 0, accent: "text-credit" },
    { key: "purchased", icon: ShoppingCart, label: t("stats.purchased"), value: `${stats.total_credits_purchased ?? 0} · \u20AC${spent}` },
    { key: "bets", icon: Target, label: t("stats.bets"), value: stats.bets_count ?? 0 },
    { key: "likes", icon: ThumbsUp, label: t("stats.likes"), value: stats.likes_given ?? 0, accent: "text-truth" },
    { key: "dislikes", icon: ThumbsDown, label: t("stats.dislikes"), value: stats.dislikes_given ?? 0, accent: "text-lie" },
    { key: "comments", icon: MessageSquare, label: t("stats.comments"), value: stats.comments_count ?? 0 },
  ];
  return (
    <div className="grid grid-cols-2 gap-px overflow-hidden border border-white/10 bg-white/10 sm:grid-cols-3" data-testid="user-stats">
      {items.map((it) => (
        <div key={it.key} className="bg-card p-5" data-testid={`stat-${it.key}`}>
          <it.icon className={`h-5 w-5 ${it.accent || "text-muted-foreground"}`} />
          <p className="mt-3 font-heading text-2xl font-black tracking-tight">{it.value}</p>
          <p className="mt-1 font-mono text-[10px] uppercase tracking-widest text-muted-foreground">{it.label}</p>
        </div>
      ))}
    </div>
  );
};
